import { DisconnectReason } from 'livekit-client';

export const DISCONNECT_REASON_MAP: Record<DisconnectReason, string> = {
  [DisconnectReason.AGENT_ERROR]: 'Agent error',
  [DisconnectReason.CLIENT_INITIATED]: 'User initiated',
  [DisconnectReason.CONNECTION_TIMEOUT]: 'Connection timeout',
  [DisconnectReason.DUPLICATE_IDENTITY]: 'Duplicate identity',
  [DisconnectReason.JOIN_FAILURE]: 'Join failure',
  [DisconnectReason.MEDIA_FAILURE]: 'Media failure',
  [DisconnectReason.MIGRATION]: 'Migration',
  [DisconnectReason.PARTICIPANT_REMOVED]: 'Participant removed',
  [DisconnectReason.ROOM_CLOSED]: 'Room closed',
  [DisconnectReason.ROOM_DELETED]: 'Room deleted',
  [DisconnectReason.SERVER_SHUTDOWN]: 'Server shutdown',
  [DisconnectReason.SIGNAL_CLOSE]: 'Signal close',
  [DisconnectReason.SIP_TRUNK_FAILURE]: 'SIP trunk failure',
  [DisconnectReason.STATE_MISMATCH]: 'State mismatch',
  [DisconnectReason.UNKNOWN_REASON]: 'Unknown reason',
  [DisconnectReason.USER_REJECTED]: 'User rejected',
  [DisconnectReason.USER_UNAVAILABLE]: 'User unavailable',
};

export const DISCONNECT_REASON_LIST = Object.values(DISCONNECT_REASON_MAP);

export const VIDEO_SESSION_ACTIVE = 'video-session-active';
export type VideoOverlaySizing = 'compact' | 'sidebar' | 'fullscreen';
export const AINotesLabel = 'AI notes';
